import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'rt_name_org1': {
    title: '分流经销商名称',
    type: 'input',
    equation: all
  },
  'rt_partner': {
    title: '分流经销商编码',
    type: 'input',
    equation: all
  },
}

export default {
  'name_org1': {
    title: '分流经销商名称',
    width: 450
  },
  'partner': {
    title: '分流经销商编号',
    width: 385
  },
  // 'zzfld000016_text': {
  //   title: '渠道',
  //   width: 300
  // },
}



// WEBPACK FOOTER //
// ./src/components/dialog/config/ShuntDealerAllSelect.js